import React from 'react';
import { FilterSelect } from '@/components/ui';

type Option = { value: string; label: string };

type Props = {
  label: string;
  htmlFor: string;
  value: string;
  options: Option[];
  onChange: (value: string) => void;
};

export default function JobStatusFilterSelect({ label, htmlFor, value, options, onChange }: Props) {
  return (
    <FilterSelect label={label} htmlFor={htmlFor}>
      <select
        id={htmlFor}
        className="filter-select"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        {options.map((opt) => (
          <option key={opt.value || 'all'} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </FilterSelect>
  );
}
